/* Native product grid: filter drawer, sort, swatches, load more, compare */
(function () {
  'use strict';

  const YES_ICON = '<svg class="ngrid__yes" viewBox="0 0 24 24" fill="none" aria-label="Yes"><path d="M5 13.3636L8.03559 16.3204C8.42388 16.6986 9.04279 16.6986 9.43108 16.3204L19 7" stroke="#16b10b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const NO_ICON = '<svg class="ngrid__no" viewBox="0 0 24 24" fill="none" aria-label="No"><path d="M16 8L8 16M8.00001 8L16 16" stroke="#e11919" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const products = root.querySelector('[data-products]');
    const compareMax = parseInt(root.dataset.compareMax || '3', 10);
    const total = parseInt(root.dataset.total || '0', 10);
    const selected = new Map();

    /* ---------- Filter drawer ---------- */
    const drawer = root.querySelector('.ngrid__drawer');
    const backdrop = root.querySelector('.ngrid__backdrop');
    const openBtn = root.querySelector('[data-open-filters]');
    function openDrawer() {
      drawer.hidden = false; backdrop.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 300);
    }
    // Active-filter badge: count checked boxes in the drawer (a colour family counts once)
    (function syncBadge() {
      if (!openBtn || !drawer) return;
      const n = drawer.querySelectorAll('input[type=checkbox]:checked').length;
      let badge = openBtn.querySelector('.ngrid__filter-count');
      if (n === 0) { badge && badge.remove(); return; }
      if (!badge) { badge = document.createElement('span'); badge.className = 'ngrid__filter-count'; openBtn.appendChild(badge); }
      badge.textContent = n;
    })();
    openBtn && openBtn.addEventListener('click', openDrawer);
    root.querySelectorAll('[data-close-filters]').forEach((el) => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeCompare(); closeSort(); } });

    // Price buckets: single choice, writes hidden min/max
    const bucketInputs = root.querySelectorAll('[data-price-bucket]');
    bucketInputs.forEach((cb) => cb.addEventListener('change', () => {
      bucketInputs.forEach((o) => { if (o !== cb) o.checked = false; });
      const min = root.querySelector('[data-price-min]');
      const max = root.querySelector('[data-price-max]');
      if (min) min.value = cb.checked ? cb.dataset.min : '';
      if (max) max.value = cb.checked ? cb.dataset.max : '';
    }));
    // Drop empty fields so URLs stay clean
    const form = root.querySelector('[data-filter-form]');
    form && form.addEventListener('submit', () => {
      form.querySelectorAll('input[type=hidden]').forEach((i) => { if (i.value === '') i.disabled = true; });
      // Colour families: one checkbox submits every underlying colour value
      form.querySelectorAll('[data-color-family]:checked').forEach((cb) => {
        cb.dataset.values.split('|~|').map((v) => v.trim()).filter(Boolean).forEach((v) => {
          const h = document.createElement('input');
          h.type = 'hidden'; h.name = cb.dataset.param; h.value = v;
          form.appendChild(h);
        });
      });
    });

    /* ---------- Sort ---------- */
    const sortToggle = root.querySelector('[data-sort-toggle]');
    const sortList = root.querySelector('[data-sort-list]');
    const sortLabel = root.querySelector('[data-sort-label]');
    const urlSort = new URLSearchParams(window.location.search).get('sort_by') || '';
    if (urlSort) root.dataset.requestedSort = urlSort;
    const currentSort = urlSort || root.dataset.sort;
    if (urlSort && form && !form.querySelector('input[name=sort_by]')) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'sort_by'; hidden.value = urlSort;
      form.appendChild(hidden);
    }
    if (sortLabel) {
      const labels = { 'most-relevant': 'Most Relevant', manual: 'Most Relevant', rating: 'Top Rated', 'best-selling': 'Best Sellers', 'price-descending': 'Price (High to Low)', 'price-ascending': 'Price (Low to High)', 'created-descending': 'Newest' };
      if (urlSort && labels[urlSort]) sortLabel.textContent = labels[urlSort];
    }
    function closeSort() { if (sortList) { sortList.hidden = true; sortToggle.setAttribute('aria-expanded', 'false'); } }
    if (sortToggle) {
      sortList.querySelectorAll('.ngrid__sort-option').forEach((li) => {
        const isSelected = urlSort ? li.dataset.sortValue === urlSort : li.textContent.trim() === 'Most Relevant';
        li.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        li.addEventListener('click', () => {
          const value = li.dataset.sortValue;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
      sortToggle.addEventListener('click', () => {
        const open = sortList.hidden;
        sortList.hidden = !open;
        sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('[data-sort-wrapper]')) closeSort(); });
    }

    /* ---------- Cards: swatches + compare ---------- */
    // Swatch fallback: if the colour image file is missing, paint a family colour from the name
    const FAMILY_COLOURS = [['black|onyx|jet|shadow|charcoal|ebony|carbon|graphite','#111'],['grey|gray|slate|titanium|silver|pewter|stone|ash|vintage|gunmetal','#8a8a8a'],['navy','#1f3a63'],['blue|azure|baltic|ocean|sky|teal|indigo|denim|cobalt|patriot|ensign|estate','#24507f'],['green|sage|olive|forest|khaki|moss','#6b7a55'],['pink|rose|orchid|lilac|blush|powder|mauve','#d9a5b3'],['red|bordeaux|crimson|burgundy|wine|tibetan|cherry','#9a2530'],['brown|espresso|tan|taupe|mocha|chocolate|bronze|cognac|walnut|coffee','#4a3226'],['white|ivory|cream|sand|pearl|bone|diamond','#fafafa'],['purple|violet|plum|lavender','#6b4a8a']];
    function swatchFallback(sw) {
      const m = (sw.style.backgroundImage || '').match(/url\(["']?([^"')]+)/);
      if (!m) return;
      const probe = new Image();
      probe.onerror = () => {
        const name = (sw.title || '').toLowerCase();
        const hit = FAMILY_COLOURS.find(([kw]) => new RegExp('\\b(' + kw + ')\\b').test(name));
        sw.style.backgroundImage = 'none';
        sw.style.backgroundColor = hit ? hit[1] : '#cfcfcf';
        if (hit && hit[1] === '#fafafa') sw.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.18)';
      };
      probe.src = m[1];
    }
    function wireCard(card) {
      card.querySelectorAll('[data-swatch]').forEach(swatchFallback);
      const primary = card.querySelector('[data-primary-img]');
      const secondary = card.querySelector('[data-secondary-img]');
      card.querySelectorAll('[data-swatch]').forEach((sw) => {
        sw.addEventListener('click', (e) => {
          e.preventDefault();
          card.querySelectorAll('[data-swatch]').forEach((o) => o.classList.remove('is-selected'));
          sw.classList.add('is-selected');
          if (primary && sw.dataset.image) { primary.src = sw.dataset.image; primary.removeAttribute('srcset'); }
          if (secondary) secondary.style.display = 'none';
          card.querySelectorAll('[data-card-link]').forEach((a) => { a.href = sw.dataset.url; });
          card.dataset.variantId = sw.dataset.variantId || card.dataset.variantId;
          card.dataset.variantAvailable = sw.dataset.available || 'true';
          const qa = card.querySelector('[data-quick-add]');
          if (qa) { const ok = card.dataset.variantAvailable === 'true'; qa.disabled = !ok; qa.querySelector('[data-quick-add-label]').textContent = ok ? 'Add to cart' : 'Sold out'; }
          const cn = card.querySelector('[data-color-name]');
          if (cn && sw.dataset.color) cn.textContent = sw.dataset.color.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());
        });
      });
      const quick = card.querySelector('[data-quick-add]');
      quick && quick.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        if (quick.disabled) return;
        const label = quick.querySelector('[data-quick-add-label]');
        quick.classList.add('is-busy'); label.textContent = 'Adding…';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
        try {
          const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(card.dataset.variantId, 10), quantity: 1 }], sections: sectionIds.join(',') })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
          const ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: {}, sourceId: 'ngrid-' + card.dataset.productId, data: { source: 'product-form-component', itemCount: 1, productId: card.dataset.productId, variantId: card.dataset.variantId, sections: data.sections } };
          document.dispatchEvent(ev);
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
          label.textContent = 'Added';
        } catch (err) {
          label.textContent = 'Try again';
          console.error(err);
        } finally {
          setTimeout(() => { quick.classList.remove('is-busy'); if (!quick.disabled && label.textContent !== 'Sold out') label.textContent = 'Add to cart'; }, 1500);
        }
      });
      const check = card.querySelector('[data-compare-check]');
      check && check.addEventListener('change', () => {
        const id = card.dataset.productId;
        if (check.checked) {
          if (selected.size >= compareMax) { check.checked = false; return; }
          const data = JSON.parse(card.querySelector('[data-compare-data]').textContent);
          selected.set(id, data);
        } else {
          selected.delete(id);
        }
        renderCompareBar();
      });
    }
    products.querySelectorAll('.ngrid__card').forEach(wireCard);

    /* ---------- Quick add placement: over the tile on hover screens, below the price on touch/narrow ---------- */
    const touchMq = window.matchMedia('(hover: none), (max-width: 989px)');
    function placeQuickAdd() {
      products.querySelectorAll('.ngrid__card').forEach((card) => {
        const btn = card.querySelector('[data-quick-add]');
        if (!btn) return;
        const media = card.querySelector('.ngrid__media');
        const details = card.querySelector('.ngrid__details');
        if (touchMq.matches) { if (btn.parentElement !== details) details.appendChild(btn); btn.classList.add('ngrid__quick-add--inline'); }
        else { if (btn.parentElement !== media) media.appendChild(btn); btn.classList.remove('ngrid__quick-add--inline'); }
      });
    }
    placeQuickAdd();
    touchMq.addEventListener ? touchMq.addEventListener('change', placeQuickAdd) : touchMq.addListener(placeQuickAdd);

    /* ---------- Compare ---------- */
    const bar = root.querySelector('[data-compare-bar]');
    const barText = root.querySelector('[data-compare-text]');
    const modal = root.querySelector('[data-compare-modal]');
    const modalBackdrop = root.querySelector('.ngrid__compare-backdrop');
    const modalProducts = root.querySelector('[data-compare-products]');
    function renderCompareBar() {
      bar.hidden = selected.size === 0;
      barText.textContent = 'Compare products (' + selected.size + ' of ' + compareMax + ')';
      root.querySelectorAll('[data-compare-check]').forEach((cb) => {
        cb.disabled = !cb.checked && selected.size >= compareMax;
      });
    }
    function truthy(v) { return /^(yes|true|y|1)$/i.test(String(v).trim()); }
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    function specHtml(spec) {
      if (spec.image) {
        if (!spec.value) return '';
        return '<img class="ngrid__compare-alt" src="' + escapeHtml(spec.value) + '" alt="" loading="lazy">';
      }
      if (spec.list) {
        const items = String(spec.value || '').split(/\r?\n|,/).map((s) => s.trim()).filter(Boolean);
        return items.map((it) => '<div class="ngrid__feature"><span>' + YES_ICON + '</span>' + escapeHtml(it) + '</div>').join('');
      }
      if (spec.boolean) {
        if (spec.value === '' || spec.value == null) return '';
        return truthy(spec.value) ? YES_ICON : NO_ICON;
      }
      return escapeHtml(spec.value || '');
    }
    function openCompare() {
      modalProducts.innerHTML = '';
      const list = Array.from(selected.values());
      list.forEach((p) => {
        const col = document.createElement('div');
        col.className = 'ngrid__compare-product';
        col.innerHTML =
          '<div class="img-outer"><img src="' + p.image + '" alt=""></div>' +
          '<a href="' + p.url + '" class="ngrid__compare-name">' + escapeHtml(p.title) + '</a>' +
          '<div class="ngrid__compare-price">' + p.price + '</div>' +
          '<a href="' + p.url + '" class="ngrid__compare-view">View Product</a>' +
          '<div class="ngrid__compare-specs">' +
          p.specs.map((s) => '<div class="ngrid__compare-spec' + (s.image ? ' ngrid__compare-spec--image' : '') + '"><div class="ngrid__compare-title">' + escapeHtml(s.label) + '</div><div class="ngrid__compare-desc">' + specHtml(s) + '</div></div>').join('') +
          '</div>';
        modalProducts.appendChild(col);
      });
      modal.hidden = false; modalBackdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      // Equalise row heights across columns (measured after the modal is visible)
      const cols = modalProducts.querySelectorAll('.ngrid__compare-product');
      const rows = cols[0] ? cols[0].querySelectorAll('.ngrid__compare-spec').length : 0;
      for (let r = 0; r < rows; r++) {
        let h = 0; const cells = [];
        cols.forEach((c) => { const cell = c.querySelectorAll('.ngrid__compare-spec')[r]; if (cell && !cell.classList.contains('ngrid__compare-spec--image')) { cells.push(cell); cell.style.height = ''; } });
        cells.forEach((cell) => { h = Math.max(h, cell.offsetHeight); });
        cells.forEach((cell) => { cell.style.height = h + 'px'; });
      }
    }
    function closeCompare() {
      if (!modal) return;
      modal.hidden = true; modalBackdrop.hidden = true;
      document.body.style.overflow = '';
    }
    root.querySelector('[data-compare-start]').addEventListener('click', openCompare);
    root.querySelectorAll('[data-compare-close]').forEach((el) => el.addEventListener('click', closeCompare));

    /* ---------- Promo tile height: match product tiles in portrait/tall modes ---------- */
    function syncPromoHeight() {
      const shaped = root.classList.contains('ngrid--shape-portrait') || root.classList.contains('ngrid--shape-tall');
      const tile = products.querySelector('.ngrid__card .ngrid__media-link');
      products.querySelectorAll('.ngrid__promo-media').forEach((m) => {
        if (shaped && tile) { m.style.height = tile.offsetHeight + 'px'; m.classList.add('is-pinned'); }
        else { m.style.height = ''; m.classList.remove('is-pinned'); }
      });
    }
    syncPromoHeight();
    window.addEventListener('resize', syncPromoHeight);
    window.addEventListener('load', syncPromoHeight);

    /* ---------- Search extras: matching pages + blog articles via the predictive search API ---------- */
    const extras = root.querySelector('[data-search-extras]');
    if (extras && extras.dataset.query) {
      const limit = parseInt(extras.dataset.limit || '6', 10);
      const url = '/search/suggest.json?q=' + encodeURIComponent(extras.dataset.query) + '&resources[type]=article,page&resources[limit]=' + limit + '&resources[options][fields]=title,body';
      fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((json) => {
        const res = (json.resources && json.resources.results) || {};
        const items = [].concat(
          (res.articles || []).map((a) => ({ type: 'Article', title: a.title, url: a.url, image: a.image, text: a.summary_html || a.body || '' })),
          (res.pages || []).map((p) => ({ type: 'Page', title: p.title, url: p.url, image: null, text: p.body || '' }))
        );
        // Regional blogs carry duplicate articles (same title in several blogs); show each title once.
        const seen = new Set();
        const unique = items.filter((it) => {
          const key = (it.title || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        }).slice(0, limit);
        if (!unique.length) return;
        const list = extras.querySelector('[data-extras-list]');
        const strip = (h) => { const d = document.createElement('div'); d.innerHTML = h; return (d.textContent || '').replace(/\s+/g, ' ').trim(); };
        list.innerHTML = unique.map((it) => {
          const media = it.image
            ? '<img class="ngrid__extra-img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') + '" alt="" loading="lazy">'
            : '<div class="ngrid__extra-img ngrid__extra-img--page" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/></svg></div>';
          const excerpt = strip(it.text).slice(0, 110);
          return '<li class="ngrid__extra"><a href="' + it.url + '" class="ngrid__extra-link">' + media +
            '<div class="ngrid__extra-body"><div class="ngrid__extra-type">' + it.type + '</div><div class="ngrid__extra-title">' + escapeHtml(it.title) + '</div>' +
            (excerpt ? '<div class="ngrid__extra-text">' + escapeHtml(excerpt) + (strip(it.text).length > 110 ? '…' : '') + '</div>' : '') + '</div></a></li>';
        }).join('');
        extras.hidden = false;
      }).catch(() => {});
    }

    /* ---------- Load more ---------- */
    const loadMore = root.querySelector('[data-load-more]');
    const shownEl = root.querySelector('[data-shown]');
    async function fetchPage(url) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-products]');
    }
    async function appendNext() {
      const next = products.dataset.nextUrl;
      if (!next) return;
      loadMore.disabled = true;
      const nextProducts = await fetchPage(next);
      if (!nextProducts) { loadMore.disabled = false; return; }
      nextProducts.querySelectorAll('.ngrid__card').forEach((card) => {
        const key = card.dataset.groupKey;
        if (key && products.querySelector('.ngrid__card[data-group-key="' + CSS.escape(key) + '"]')) return; // sibling already shown
        products.appendChild(card); wireCard(card);
      });
      placeQuickAdd();
      products.dataset.nextUrl = nextProducts.dataset.nextUrl || '';
      shownEl.textContent = Math.min(products.querySelectorAll('.ngrid__card').length, total);
      if (!products.dataset.nextUrl) loadMore.remove(); else loadMore.disabled = false;
    }
    loadMore && loadMore.addEventListener('click', appendNext);

    /* ---------- Top Rated: client-side sort over the full result set ---------- */
    async function applyRatingSort() {
      while (products.dataset.nextUrl) {
        const nextProducts = await fetchPage(products.dataset.nextUrl);
        if (!nextProducts) break;
        nextProducts.querySelectorAll('.ngrid__card').forEach((card) => {
          const key = card.dataset.groupKey;
          if (key && products.querySelector('.ngrid__card[data-group-key="' + CSS.escape(key) + '"]')) return;
          products.appendChild(card); wireCard(card);
        });
        products.dataset.nextUrl = nextProducts.dataset.nextUrl || '';
      }
      const cards = Array.from(products.querySelectorAll('.ngrid__card'));
      cards.sort((a, b) => {
        const ra = parseFloat(a.dataset.rating) || 0, rb = parseFloat(b.dataset.rating) || 0;
        if (rb !== ra) return rb - ra;
        return (parseInt(b.dataset.ratingCount) || 0) - (parseInt(a.dataset.ratingCount) || 0);
      });
      cards.forEach((c) => products.appendChild(c));
      // Put promo tiles back at their configured row and side
      Array.from(products.querySelectorAll('.ngrid__promo')).forEach((p) => {
        const row = parseInt(p.dataset.promoRow || '2', 10);
        const span = parseInt(p.dataset.promoSpan || '2', 10);
        const idx = (row - 1) * 4 + (p.dataset.promoSide === 'left' ? 0 : 4 - span);
        const anchor = products.querySelectorAll('.ngrid__card')[idx];
        if (anchor) products.insertBefore(p, anchor); else products.appendChild(p);
      });
      if (shownEl) shownEl.textContent = Math.min(cards.length, total);
      if (loadMore) loadMore.remove();
      if (sortLabel) sortLabel.textContent = 'Top Rated';
    }
    if (root.dataset.requestedSort === 'rating') applyRatingSort();
  }

  function boot() { document.querySelectorAll('.ngrid').forEach((root) => { if (!root.dataset.inited) { root.dataset.inited = '1'; init(root); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
